import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ProductionProcessReferenceService extends BaseReferenceService {
  constructor() {
    super('ProductionProcessReference');
  }
}
